module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPHBhdGggZmlsbD0iI2QyMTAzNCIgZD0iTTAgMGg2NDB2NDgwSDB6Ii8+CiAgPHBhdGggZmlsbD0iIzAwN2UzYSIgZD0iTTEyMCAxMjBoNDAwdjI0MEgxMjB6Ii8+CiAgPGNpcmNsZSByPSI4MCIgY3k9IjI0MCIgY3g9IjM1MCIgZmlsbD0iI2ZmZiIvPgogIDxjaXJjbGUgcj0iODAiIGN5PSIyNDAiIGN4PSIzODAiIGZpbGw9IiMwMDdlM2EiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/mv.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/mv.svg
// module chunks = 0